import React, { useCallback, useMemo } from 'react'
import styled from 'styled-components'
import { theme } from 'styled-tools'
import useTranslation from '../../../../utils/translation'
import CheckBox from '../../customer-form/checkbox'
import RadioButton from '../../customer-form/radioButton'

const SelectWrapper = styled.div`
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: -8px;

  & label {
    margin: 0;
    font-weight: normal;

    &:has(input[type='checkbox']) {
      margin-bottom: 5px;
    }
  }
`

const ErrorMessage = styled.span`
  color: ${theme('forms.colors.invalid')};
  font-size: ${theme('forms.errorMessage.fontSize')};
  text-align: left;
  display: block;
  padding-top: 7px;
`

export const FormSelectQuestion = ({ question, answers, onChange }) => {
  const t = useTranslation('app.form')
  const isMulti = question.optionType === 'multi'
  const inputName = question.questionText.replaceAll(' ', '')

  const onSingleChange = useCallback(
    (event) => {
      const { checked, value } = event.target
      if (checked) {
        onChange([value])
      } else {
        onChange([])
      }
    },
    [onChange]
  )

  const onMultiChange = useCallback(
    (event) => {
      const { checked, value } = event.target
      if (checked) {
        onChange([...answers, value])
      } else {
        onChange(answers.filter((a) => a !== value))
      }
    },
    [answers, onChange]
  )

  const onSelectChange = isMulti ? onMultiChange : onSingleChange

  const errorMessage = useMemo(() => {
    if (question.notAnswered === undefined) {
      return undefined
    }
    if (question.notAnswered) {
      return question.requiredText || t('required')
    }
    return undefined
  }, [question.notAnswered, question.requiredText, t])

  if (!question.options?.length) {
    return null
  }

  return (
    <>
      <SelectWrapper>
        {question.options.map((o) => {
          const checked = answers.includes(o.name)
          const Control = isMulti ? CheckBox : RadioButton

          return (
            <Control
              key={o.name}
              data-selected={checked}
              data-track={`option-${o.name}`.toLowerCase()}
              value={o.name}
              checked={checked}
              onChange={onSelectChange}
              label={o.text || o.firstText || o.name}
              name={isMulti ? `${inputName}-${o.name}` : inputName}
            />
          )
        })}
      </SelectWrapper>
      {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
    </>
  )
}
